// extracted by mini-css-extract-plugin
export default {"appsReport":"appsReport__XoxxXs","loading":"loading__kW0zgZ","appsList":"appsList__M9DoOP"};